var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("html", [
    _vm._m(0),
    _c("body", [
      _c("div", { staticClass: "capa1" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "p-4 col-lg-4 col-10" }),
            _c("div", { staticClass: "col-lg-4" }, [
              _c("div", { staticClass: "mx-auto bg-light p-3 lpp4" }, [
                _c("div", { staticClass: "border-top-0 px-3 pt-5" }, [
                  _c("h6", { staticClass: "text-center mt-3 mb-4" }, [
                    _vm._v("Digite o código de acesso enviado."),
                  ]),
                  _c(
                    "form",
                    {
                      on: {
                        submit: [
                          _vm.login,
                          function ($event) {
                            $event.preventDefault()
                          },
                        ],
                      },
                    },
                    [
                      _c("div", { staticClass: "form-group mb-3" }, [
                        _c("div", { staticClass: "form-group mb-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.promocode,
                                expression: "form.promocode",
                              },
                            ],
                            staticClass:
                              "form-control form-control-sm col-9 mx-auto",
                            attrs: { type: "password", id: "form" },
                            domProps: { value: _vm.form.promocode },
                            on: {
                              change: function ($event) {
                                return _vm.eventChangeAccessCodeInputGTM()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.form,
                                  "promocode",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-lg d-flex my-4 mx-auto",
                          attrs: {
                            type: "submit",
                            disabled: _vm.loading,
                            id: "confirm",
                          },
                        },
                        [_vm._v("Confirmar")]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("ProgressLoading", {
                        attrs: { loading: _vm.loading },
                      }),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "small text-center mt-4" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-primary",
                        attrs: { href: "#" },
                        on: { click: _vm.voltar },
                      },
                      [_vm._v("Reenviar código")]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "p-4 col-lg-4 col-10" }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("head", [
      _c("meta", { attrs: { charset: "utf-8" } }),
      _c("meta", {
        attrs: {
          name: "viewport",
          content: "width=device-width, initial-scale=1",
        },
      }),
      _c("link", { attrs: { rel: "icon", href: "img/favicon.ico" } }),
      _c("link", {
        attrs: { rel: "stylesheet", href: "theme.css", type: "text/css" },
      }),
      _c("title", [_vm._v("Porto - Portal de Autonegociação")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }